import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Field, ErrorMessage, getIn, Formik, Form } from 'formik'
import { toastr } from 'react-redux-toastr'
import { memberService } from '../_services/member.service'
import * as Yup from 'yup'
import NumberFormat from 'react-number-format'
import UnionSelect from '../_components/Shared/UnionSelect'
import ErrorPopUp from '../_components/Shared/ErrorPopUp'
import Step1 from './Step1'

import { config } from '../config'
const base_url = config.apiBaseUrl

class PaymentForm extends Component {
  state = {
    currentStep: 0,
    lastStep: 0
  }

  prevStep = props => {
    // Prev Step dont undes 0
    this.setState(state => ({
      currentStep: Math.max(state.currentStep - 1, 0)
    }))
    props.setTouched({})
  }

  nextStep = props => {
    // console.log(props.values);

    // Next Step dont go over Max step
    // console.log(props.errors);
    // props.submitForm().then(() => {
    if (props.isValid) {
      this.setState(state => ({
        currentStep: Math.min(state.currentStep + 1, state.lastStep)
      }))
      // props.validateForm();
      props.setTouched({})
    }
    // });
  }

  Step1Schema = Yup.object().shape({
    unionId: Yup.string().required('اتحادیه'),

    nationalCode: Yup.string()
      .matches(/^[0-9]\d{9}$/, {
        message: 'کد ملی باید شامل 10 رقم باشد',
        excludeEmptyString: false
      })
      .required('وارد کردن [کد ملی] الزامی است')
  })

  schemaArray = [this.Step1Schema, this.Step2Schema, this.Step3Schema]

  handleSubmit = (values, formikbag) => {
    // do stuff
    setTimeout(() => {
      formikbag.setSubmitting(false)
    }, 1000)
  }

  step1 = props => {
    if (this.state.currentStep == 0) {
      return (
        <div>
          <Step1 {...props} />
          {/* <br/>
          <button className="nextButton pull-right" onClick={() => { this.nextStep(props) }}>
            مرحله بعد
          </button> */}
        </div>
      )
    }
  }

  //   step2 = props => {
  //     if (this.state.currentStep == 1) {
  //       return (
  //         <div>
  //         <Step2 {...props} />
  //           <br/>
  //           <button className="nextButton pull-right" onClick={() => { this.nextStep(props) }}>
  //             مرحله بعد
  //           </button>
  //           <button className="previousButton pull-right" onClick={() => { this.prevStep(props) }}>
  //             مرحله قبل
  //           </button>
  //         </div>
  //       );
  //     }
  //   };

  //   step3 = props => {
  //     if (this.state.currentStep == 2) {
  //       return (
  //         <div>
  //         <Step3 {...props} />
  //           <br/>
  //           <button className="nextButton pull-right" type="submit">
  //             ذخیره
  //           {props.isSubmitting &&
  //                     <i className="mdi mdi-24px mdi-spin mdi-loading"></i>
  //                     }
  //           </button>
  //           <button className="previousButton pull-right" onClick={() => { this.prevStep(props) }}>
  //           مرحله قبل
  //           </button>
  //         </div>
  //       );
  //     }
  //   };

  handleSubmit = values => {
    // console.log(JSON.stringify(values));

    memberService
      .transferToBank(values.nationalCode, values.unionId)
      .then(res => {
        var memberInfo = {}
        memberInfo = res.data
        // console.log(memberInfo);

        this.props.changeMode(3, memberInfo)
        // window.location.assign(base_url + 'bank/TransferToBank/' + res.data)
        // this.setState({ loading: false, modal: false });
        //   toastr.success('ثبت برند جدید', 'برند جدید  "' + values.name + '" با موفقیت ثبت شد');
      })
      .catch(error => {
        toastr.success(
          '',
          'اطلاعات شما در سیستم یافت نشد. لطفا دوباره ثبت نام نمائید.'
        )
        // console.log(error)
      })
  }

  render() {
    const { currentStep } = this.state
    const { prevStep, nextStep, schemaArray } = this
    return (
      <div className="ltr">
        <br />
        <div className="header">
          <h1>ﭘﺮداﺧﺖ آﻧﻼﯾﻦ ﻫﺰﯾﻨﻪ ﮐﻼس</h1>
          <p>
            در ﺻﻮرﺗﯽ ﮐﻪ ﻣﻮﻓﻖ ﺑﻪ ﭘﺮداﺧﺖ آﻧﻼﯾﻦ ﻫﺰﯾﻨﻪ دوره آﻣﻮزﺷﯽ ﻧﺸﺪه اﯾﺪ
            <br />
            ﭘﺲ از وارد ﮐﺮدن ﮐﺪ ﻣﻠﯽ و ﻧﺎم اﺗﺤﺎدﯾﻪ ﺧﻮد ﻧﺴﺒﺖ ﺑﻪ ﭘﺮداﺧﺖ ﺑﺼﻮرت آﻧﻼﯾﻦ
            اﻗﺪام ﻧﻤﺎﯾﯿﺪ
          </p>
        </div>

        <br />
        <Formik
          onSubmit={(values, { setSubmitting }) => {
            // console.log(values);
            this.handleSubmit(values)
            setSubmitting(false)
          }}
          enableReinitialize
          initialValues={{
            unionId: undefined,
            nationalCode: ''
          }}
          validationSchema={schemaArray[currentStep]}>
          {props => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              setFieldValue,
              handleSubmit
            } = props
            return (
              <Form>
                <div className="row">
                  <div className="col-md-8 col-md-offset-2">
                    <div className="form-inline">
                      <div className="col-md-2">
                        <label>کد ملی</label>
                      </div>
                      <div className="col-md-4">
                        <NumberFormat
                          format="##########"
                          isNumericString
                          allowNegative={false}
                          name="nationalCode"
                          onChange={e => {
                            setFieldValue('nationalCode', e.target.value)
                          }}
                          onBlur={handleBlur}
                          value={values.nationalCode}
                          className={
                            errors.nationalCode && touched.nationalCode
                              ? 'text-input numberFa has-error'
                              : 'text-input numberFa required'
                          }
                        />

                        {getIn(errors, 'nationalCode') &&
                        getIn(touched, 'nationalCode') ? (
                          <div className={'required_validator visible'}>
                            <div className="validator_container">
                              <span>{errors.nationalCode}</span>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>

                      <div className="clearfix" />

                      <div className="col-md-2">
                        <label>اتحادیه</label>
                      </div>
                      <div className="col-md-10 rtl">
                        <UnionSelect
                          required
                          defaultValue={values.unionId}
                          onChange={val => {
                            setFieldValue('unionId', val)
                          }}
                        />
                        <ErrorMessage component={ErrorPopUp} name="unionId" />
                      </div>

                      <div className="clearfix" />

                      <div className="col-md-10 col-md-offset-2 text-center">
                        <div className="btns">
                          <button
                            className="cancelPaymentBtn"
                            onClick={() => this.props.cancelPaymentBtn()}>
                            ثبت نام جدید
                          </button>
                          <button className="paymentBtn">ﭘﺮداﺧﺖ آﻧﻼﯾﻦ</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )
          }}
        </Formik>
      </div>
    )
  }
}

export default PaymentForm
